type Props = {
  text: string;
};

export function UrgencyBar({ text }: Props) {
  return (
    <div class="urgency-bar" style="padding-left: 0">
      <svg
        class="urgency-bar__icon"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="#444"
        style="flex-shrink: 0"
      >
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z" />
      </svg>
      <span class="urgency-bar__text">{text}</span>
    </div>
  );
}
